import { connect } from 'react-redux';
import { compose } from 'redux';
import Fills from '../../../components/handoff/sidebar/Fills';
import onlyIf from '../../../hocs/onlyIf';
import { getSelectedElement } from '../../../selectors/handoff';
import * as elementUtils from '../../../utils/handoff/element';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    if (!element) {
        return {};
    }
    var fills = elementUtils.getFills(element);
    if (!fills.length) {
        return {};
    }
    return {
        fills: fills,
    };
}
export default compose(connect(mapStateToProps), onlyIf(function (props) { return props.fills; }))(Fills);
